// External Controller
// Handles external API operations

import { post } from './utilitiesController.js';

/**
 * Submit external consultation request
 * @param {Object} data - Data containing email and partner_name
 * @returns {Promise} - Response from external consultations endpoint
 */
export const submitExternalConsultation = async (data) => {
    try {
        const response = await post('api/external/consultations', data, true);
        return response;
    } catch (error) {
        console.error('Failed to submit external consultation:', error);
        throw error;
    }
};

/**
 * Get external chat messages
 * @param {Object} data - Data containing care_consultation_id
 * @returns {Promise} - Response from external chat messages endpoint
 */
export const getExternalChatMessages = async (data) => {
    try {
        const response = await post('api/external/chat_messages', data, true);
        return response;
    } catch (error) {
        console.error('Failed to get external chat messages:', error);
        throw error;
    }
};

/**
 * Get all engagements for an incubation
 * @param {Object} data - Data containing incubation_id, page, limit
 * @returns {Promise} - Response from incubation engagements endpoint
 */
export const getIncubationEngagements = async (data) => {
    try {
        const response = await post('api/external/incubation-engagements', data, true);
        return response;
    } catch (error) {
        console.error('Failed to get incubation engagements:', error);
        throw error;
    }
};

/**
 * Export all engagements for an incubation (for CSV download)
 * @param {Object} data - Data containing incubation_id
 * @returns {Promise} - Response from incubation engagements export endpoint
 */
export const exportIncubationEngagements = async (data) => {
    try {
        const response = await post('api/external/incubation-engagements-export', data, true);
        return response;
    } catch (error) {
        console.error('Failed to export incubation engagements:', error);
        throw error;
    }
};

export default {
    submitExternalConsultation,
    getExternalChatMessages,
    getIncubationEngagements,
    exportIncubationEngagements
};
